import {useMutation} from "@tanstack/react-query";
import {readRevenueLastYear} from "../../../../../api/main/SalesApi";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";

export const useReadRevenueLastYear = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: () => readRevenueLastYear(),
        onSuccess: () => {
        },
        onError: (error: AxiosError) => {
            console.log(error);
            if (error?.response?.data instanceof Blob) {
                error.response.data.text().then((value) => {
                    const obj = JSON.parse(value);
                    handleModal({
                        isOpen: true,
                        contents: obj?.msg,
                        type: "alert"
                    });
                });
            }
        },
    })

    return {mutate, mutateAsync}
};
